import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class ScoringSubmitted extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  render() {

    return (
      <div className="onboarding-scoringsubmitted-container">
        <div className="onboarding-title">
          Submission Successful
        </div>
        <div className="onboarding-biglabel onboarding-scoringsubmitted-body">
          We are currently processing your application and will get back to you soon! We’ll email you when its time to move forward.
        </div>
      </div>
    );  }

}

export default ScoringSubmitted;
